import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

import { env } from '@/env';
import { rootGuards } from '@/shell/auth/guards';
import { aggregateFeatureRoutes } from '@/shell/feature-registry';

export function createShellRouter() {
  const featureRoutes = aggregateFeatureRoutes();
  const routes: RouteRecordRaw[] = [
    {
      path: '/',
      redirect: '/auctions',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/shell/components/LoginScreen.vue'),
      meta: { skipAuctionLoad: true },
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: () => import('@/shell/components/ForbiddenScreen.vue'),
      meta: { skipAuctionLoad: true },
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/shell/components/AuthCallbackPage.vue'),
      meta: { skipAuctionLoad: true },
    },
    {
      path: '/auth/adopt',
      name: 'auth-adopt',
      component: () => import('@/shell/components/AuthAdoptPage.vue'),
      meta: { skipAuctionLoad: true },
    },
    {
      path: '/no-access',
      name: 'org-no-access',
      component: () => import('@/shell/components/OrgNoAccessScreen.vue'),
      meta: { skipAuctionLoad: true },
    },
    {
      path: '/select-organization',
      name: 'select-organization',
      component: () => import('@/shell/components/OrgSelectionPage.vue'),
      meta: { skipAuctionLoad: true },
    },
    ...featureRoutes,
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/shell/components/NotFound.vue'),
      meta: { skipAuctionLoad: true },
    },
  ];

  const router = createRouter({
    history: createWebHistory(env.baseUrl),
    routes,
  });

  router.onError((error, to) => {
    const msg = error instanceof Error ? error.message : String(error);
    if (
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed')
    ) {
      const key = `admin-web:chunk-reload:${to.fullPath}`;
      if (sessionStorage.getItem(key) === '1') return;
      sessionStorage.setItem(key, '1');
      window.location.assign(to.fullPath);
    }
  });

  rootGuards(router);
  return router;
}
